document.addEventListener("DOMContentLoaded", function () {
  var selectedVariants = [];
  var maxSelection = 3;
  var bundleKey = "trial_bundle";
  var isAddingBundle = false;
  var cleanupInterval = null;
  var bundleInCart = false; // 🔑 track state

  var $progressSlots = $(".trial-thumb-container");
  var $mainButton = $("#trial-bundle-1");
  var $btnText = $mainButton.find(".btn-text");

  // ---------------------------
  // PRODUCT SELECTION
  // ---------------------------
  $(".trial-pack-item").on("click", function (e) {
    if ($(e.target).closest(".trial-add-to-cart").length) return;

    var $this = $(this);

    // remove "flipped" from all others
    $(".trial-pack-item").not($this).removeClass("flipped");

    // toggle only the clicked one
    $this.toggleClass("flipped");
  });

  $(".trial-add-to-cart").on("click", function (e) {
    e.preventDefault();

    var $button = $(this);
    var variantId = String($button.data("variant-id"));
    var imgSrc = $button.closest(".trial-pack-item").find("img").attr("src") || "";

    if (selectedVariants.find(v => v.id === variantId)) return;
    if (selectedVariants.length >= maxSelection) {
      alert("You can select only " + maxSelection + " products.");
      return;
    }

    selectedVariants.push({ id: variantId, img: imgSrc });
    updateProgressBar();
    $button.prop("disabled", true).text("Selected");
  });

  // ---------------------------
  // REMOVE SELECTION OR CART
  // ---------------------------
  $(document).on("click", ".trial-remove-selected", function () {
    var index = Number($(this).data("index"));
    var removed = selectedVariants[index];
    if (!removed) return;

    if (bundleInCart) {
      if (confirm("This trial bundle is already in your cart. Do you want to remove it?")) {
        removeBundleFromCart().then(() => {
          resetUI();
          alert("Trial bundle removed from cart.");
        });
      }
      return;
    }

    $(".trial-add-to-cart[data-variant-id='" + removed.id + "']")
      .prop("disabled", false)
      .text("Try This One");

    selectedVariants.splice(index, 1);
    updateProgressBar();
  });

  // ---------------------------
  // ADD BUNDLE
  // ---------------------------
  $mainButton.on("click", function (e) {
    e.preventDefault();

    if (bundleInCart) {
      alert("Trial bundle is already in your cart. Please remove it first.");
      return;
    }

    if (selectedVariants.length !== maxSelection) {
      alert("Please select exactly " + maxSelection + " products.");
      return;
    }

    isAddingBundle = true;
    $mainButton.prop("disabled", true);
    $btnText.text("Processing...");

    removeBundleFromCart()
      .then(() => {
        let i = 0;
        function addNext() {
          if (i >= selectedVariants.length) {
            isAddingBundle = false;
            bundleInCart = true; // ✅ mark as in cart
            $mainButton.prop("disabled", false);
            $btnText.text("Already Added"); // ✅ stable button text
            validateCart(true); // force sync
            return;
          }
          var variant = selectedVariants[i];
          fetch("/cart/add.js", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              id: variant.id,
              quantity: 1,
              properties: { [bundleKey]: "true" }
            })
          })
            .then(() => {
              i++;
              addNext();
            })
            .catch(err => {
              console.error("⚠️ Error adding", variant.id, err);
              isAddingBundle = false;
              $mainButton.prop("disabled", false);
              $btnText.text("Add to Cart");
            });
        }
        addNext();
      });
  });

  // ---------------------------
  // PROGRESS BAR
  // ---------------------------
  function updateProgressBar() {
    $progressSlots.each(function (i) {
      var $slot = $(this);
      var data = selectedVariants[i];
      if (data) {
        $slot.find(".trial-selected-img").attr("src", data.img).show();
        $slot.find(".trial-step-placeholder, .trial-step-label").hide();
        $slot.find(".trial-remove-selected").show();
      } else {
        $slot.find(".trial-selected-img").hide().attr("src", "");
        $slot.find(".trial-step-placeholder, .trial-step-label").show();
        $slot.find(".trial-remove-selected").hide();
      }
    });

    if (!bundleInCart) {
      if (selectedVariants.length === maxSelection) {
        $mainButton.prop("disabled", false);
        $btnText.text("Add to Cart");
      } else {
        $mainButton.prop("disabled", true);
        $btnText.text("Add to Cart");
      }
    }
  }

  function resetUI() {
    selectedVariants = [];
    bundleInCart = false;
    updateProgressBar();
    $(".trial-add-to-cart").prop("disabled", false).text("Try This One");
    $mainButton.prop("disabled", true);
    $btnText.text("Add to Cart");
  }

  // ---------------------------
  // CART HELPERS
  // ---------------------------
  function removeBundleFromCart() {
    return fetch("/cart.js")
      .then(r => r.json())
      .then(cart => {
        var trialItems = cart.items.filter(
          item => item.properties && item.properties[bundleKey] === "true"
        );
        if (trialItems.length === 0) return;
        var removals = trialItems.map(item =>
          fetch("/cart/change.js", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ id: item.key, quantity: 0 })
          })
        );
        return Promise.all(removals);
      });
  }

  // ---------------------------
  // VALIDATION
  // ---------------------------
  function validateCart(force = false) {
    if (isAddingBundle) return;

    fetch("/cart.js")
      .then(r => r.json())
      .then(cart => {
        var trialItems = cart.items.filter(
          item => item.properties && item.properties[bundleKey] === "true"
        );

        if (trialItems.length === 0) {
          if (bundleInCart || force) resetUI();
          return;
        }

        if (trialItems.length === maxSelection) {
          if (!bundleInCart || force) {
            bundleInCart = true;
            selectedVariants = trialItems.map(item => ({
              id: String(item.variant_id),
              img: item.image || ""
            }));

            $(".trial-add-to-cart").each(function () {
              var $btn = $(this);
              var variantId = String($btn.data("variant-id"));
              if (selectedVariants.find(v => v.id === variantId)) {
                $btn.prop("disabled", true).text("Selected");
              } else {
                $btn.prop("disabled", false).text("Try This One");
              }
            });

            updateProgressBar();
            $mainButton.prop("disabled", false);
            $btnText.text("Already Added"); // ✅ will not flicker anymore
          }
          return;
        }

        // Invalid state → clean up
        removeBundleFromCart().then(() => resetUI());
      })
      .catch(err => console.error("⚠️ validateCart error", err));
  }

  // ---------------------------
  // INIT
  // ---------------------------
  document.addEventListener("cart:updated", () => validateCart(true));
  document.addEventListener("cart:refresh", () => validateCart(true));

  if (!cleanupInterval) {
    cleanupInterval = setInterval(validateCart, 2200); // ✅ safe now
  }

  validateCart(true);
});
